var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 58,
    viewBox: "0 0 159 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 58H157.642C158.978 58 158.637 56.8992 159 55.6715C156.026 44.5515 137.645 50.5029 129.467 50.8398C127.137 41.1106 122.19 19.9984 107.901 30.8797C108.739 14.7631 97.2131 2.59911 81.7321 0.37151C62.5429 -2.39025 57.1577 10.6142 53.101 27.1397C40.335 20.1605 21.788 31.9543 20.1892 46.2963C12.0122 42.096 1.7251 48.3798 0 58Z",
    fill: "#FFEBD8",
    fillOpacity: 0.67
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOrange);
export default __webpack_public_path__ + "static/media/cloud-orange.e8374ce9c06cb72566883ae926958bd0.svg";
export { ForwardRef as ReactComponent };